var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { Category, getAmplifyUserAgent, Hub, } from '@aws-amplify/core';
import { AMPLIFY_SYMBOL } from './StorageConstants';
export var byteLength = function (x) {
    if (typeof x === 'string') {
        return x.length;
    }
    else if (isArrayBuffer(x)) {
        return x.byteLength;
    }
    else if (isBlob(x)) {
        return x.size;
    }
    else {
        throw new Error('Cannot determine byte length of ' + x);
    }
};
export var dispatchStorageEvent = function (track, event, attrs, metrics, message) {
    if (track) {
        var data = { attrs: attrs };
        if (metrics) {
            data['metrics'] = metrics;
        }
        Hub.dispatch('storage', {
            event: event,
            data: data,
            message: message,
        }, 'Storage', AMPLIFY_SYMBOL);
    }
};
export var isFile = function (x) {
    return typeof x !== 'undefined' && x instanceof File;
};
export var isBlob = function (x) {
    return typeof x !== 'undefined' && x instanceof Blob;
};
export var getStorageUserAgentValue = function (action, customUserAgentDetails) {
    return getAmplifyUserAgent(__assign({ category: Category.Storage, action: action }, customUserAgentDetails));
};
var isArrayBuffer = function (x) {
    return typeof x !== 'undefined' && x instanceof ArrayBuffer;
};
